import { END_DATE_FILTER_KEY, START_DATE_FILTER_KEY, useAssignmentService } from 'domain/shared/assignment';
import { ResourceData } from 'framework/crud';
import { cloneDeep, get, set } from 'lodash';
import { useDateService } from 'framework/utils';
import { FilterCondition } from 'framework/types';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { DEFAULT_ERROR_MESSAGE } from 'framework/form';

// Grouped by specialization
const groupedBySpecialization = (array: any) => {
  return array.reduce((acc: any, employee: any) => {
    const spec = employee.employeeSpecialization;
    if (!acc[spec]) {
      acc[spec] = {
        employeeSpecialization: spec,
        employees: [],
      };
    }
    acc[spec].employees.push(employee);
    return acc;
  }, {} as any);
};

function mapToBenchFormat(source: any) {
  return {
    employeeAlias: source.employeeId,
    employeeName: source.employeeName,
    employeeSpecialization: source.position?.name || null,
    benchProject: source.target?.displayName || null,
    benchMinAssing: source.minPercent,
    benchMaxAssing: source.maxPercent,
    dudationStart: source.from,
  };
}

const useBenchService = () => {
  const { addMessage } = useMessageService();
  const { getMaxDate, getMinDate, getToday, formatDateForAPI, getMomentDateObj } = useDateService();
  const today = getToday();
  const { searchAll } = useAssignmentService();

  const getBenchListDataMethod = async (request: ResourceData) => {
    try {
      const searchParams = cloneDeep(request);

      const startDateFilterKey = `${START_DATE_FILTER_KEY}.${FilterCondition.LE}`;
      const endDatFilterKey = `${END_DATE_FILTER_KEY}.${FilterCondition.GE}`;

      const newFilterEndDate = getMaxDate([today, getMomentDateObj(get(request, endDatFilterKey) || today)]);
      const newFilterStartDate = getMinDate([today, getMomentDateObj(get(request, startDateFilterKey) || today)]);

      set(searchParams, startDateFilterKey, formatDateForAPI(newFilterStartDate));
      set(searchParams, endDatFilterKey, formatDateForAPI(newFilterEndDate));

      const response = await searchAll({
        ...searchParams,
        filter: {
          ...searchParams?.filter,
          bench: {
            eq: true,
          },
        },
        sort: {
          updatedAt: 'DESC',
        },
        pageSize: 30,
        pageNumber: 0,
      });

      // TODO Addtional text and status
      return {
        result: Object.values(groupedBySpecialization(response.map(mapToBenchFormat))) as Dictionary<any>[],
      };
    } catch {
      addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
      return {
        result: [],
      };
    }
  };

  return {
    getBenchListDataMethod,
  };
};

export default useBenchService;
